// extracted by mini-css-extract-plugin
module.exports = {"btn":"AddButton_btn__21DXR","disabled":"AddButton_disabled__1h68h","text":"AddButton_text__bRJZF"};